"use client";

import {
  DIAGNOSIS_UNLOCK_LOADING_HERO_FIGMA,
  DIAGNOSIS_UNLOCK_LOADING_HERO_LAYOUT,
} from "./diagnosisUnlockLoadingHero.contract";

const L = DIAGNOSIS_UNLOCK_LOADING_HERO_LAYOUT;

/**
 * DiagnosisUnlock Loading 顶部 hero — 圆 + 方「i」形。
 * 字面映射 Figma `90772:39831`（37.333×80，非通用 Loading 56px 圆）。
 */
export function DiagnosisUnlockLoadingHeroIcon() {
  return (
    <div
      className="relative shrink-0"
      style={{
        width: L.widthPx,
        height: L.heightPx,
      }}
      data-testid="diagnosis-unlock-loading-hero-icon"
      data-figma-node-id={DIAGNOSIS_UNLOCK_LOADING_HERO_FIGMA.group}
    >
      <div
        className="absolute left-0 top-0 rounded-full bg-content_aura_lv3_primary"
        style={{
          width: L.headSizePx,
          height: L.headSizePx,
        }}
        data-testid="diagnosis-unlock-loading-icon-head"
        data-figma-node-id={DIAGNOSIS_UNLOCK_LOADING_HERO_FIGMA.ellipse}
      />
      <div
        className="absolute bg-content_aura_lv3_primary"
        style={{
          left: L.bodyLeftPx,
          top: L.bodyTopPx,
          width: L.bodySizePx,
          height: L.bodySizePx,
          borderRadius: L.bodyRadiusPx,
        }}
        data-testid="diagnosis-unlock-loading-icon-body"
        data-figma-node-id={DIAGNOSIS_UNLOCK_LOADING_HERO_FIGMA.body}
      />
    </div>
  );
}
